/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.anchorLink)();
	(0, _module.mainNavCurrent)();
	(0, _module.modalPopup)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPointPC = 1279;
	var breakPointSP = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// visibleButton
	// ----- BOTH
	// ------------------------------------------------------------------------
	var visibleButton = function visibleButton() {
	  var targetButton = document.querySelector('.sw-Top');
	  var targetHeight = 100;
	  window.addEventListener('scroll', function () {
	    var scrollHeight = window.pageYOffset;
	    if (scrollHeight > targetHeight) {
	      targetButton.classList.remove('is-Hidden');
	    } else {
	      targetButton.classList.add('is-Hidden');
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var mainNavCurrent = function mainNavCurrent() {
	  $(function () {
	    var href = window.location.href;
	    $('nav ul li').each(function (i) {
	      var url = $(this).children('a').prop('href');
	      if (href === url) {
	        $(this).children('a').addClass('current');
	      } else {
	        $(this).children('a').removeClass('current');
	      }
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// modalPopup
	// ----- BOTH
	// ------------------------------------------------------------------------
	var modalPopup = function modalPopup() {
	  $(function () {
	    $('nav li:last-of-type').click(function () {
	      $('.st-Footer_Modal').fadeIn();
	    });
	    $('.close-modal , .modal-bg').click(function () {
	      $('.st-Footer_Modal').fadeOut();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// mhowMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + '%', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	    //
	    // $modal.stop().fadeOut(300, function(){
	    //   $content.children('iframe').remove();
	    // });
	  });
	};
	
	exports.visibleButton = visibleButton;
	exports.anchorLink = anchorLink;
	exports.mainNavCurrent = mainNavCurrent;
	exports.modalPopup = modalPopup;
	exports.showMovie = showMovie;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js